































import { Component, Prop, Vue } from 'vue-property-decorator';
import DropdownDotsIcon from '@/svg/dropdown-dots.svg';
import ArrowDownIcon from '@/svg/arrow-down.svg';
import ArrowUpIcon from '@/svg/arrow-up.svg';
import CrossIcon from '@/svg/cross.svg';

@Component({
  components: { DropdownDotsIcon, ArrowDownIcon, ArrowUpIcon, CrossIcon }
})
export default class UiKitImageDropdown extends Vue {
  @Prop({}) public name: string;
  @Prop({}) public index: number;
  @Prop({}) public itemsCount: number;

  protected isOpen = false;
}
